import wpCall from "../services/WpServerCall";
import apiServiceCall from "../services/ApiServiceCall";

export const getHomeImages = () => {
    return wpCall().get('/homeImage/v1/web').then(({ data }) => data);
}

export const getHomeMotto = () => {
    return wpCall().get('/motto/v1/web').then(({ data }) => data);
}

export const getCarouselImages = () => {
    return wpCall().get('/listOfImages/v1/web').then(({ data }) => data);
}

export const getHomeMetricsData = () => {
    // return apiServiceCall().get('/statistics').then(({ data }) => data);
    return wpCall().get('/listOfMetrics/v1/web').then(({ data }) => data);
}

export const getInfoFooter = () => {
    return wpCall().get('/footer/v1/web').then(({ data }) => data);
}
